import Button, { ButtonProps } from '@mui/material/Button';
import cn from 'classnames';
import React from 'react';

import s from '../common/Button.module.scss';

const CustomButton = (props: ButtonProps) => {
  const textBtnColor =
    props.variant === 'text' && props.color !== 'inherit' ? { color: 'text.secondary' } : {};

  return (
    <Button
      disableRipple
      disableElevation
      {...props}
      sx={{
        ...textBtnColor,
        ...props.sx
      }}
      variant={props.variant || 'contained'}
      classes={{ ...props.classes, root: cn(props?.classes?.root, s['MaterialButton-root']) }}
    />
  );
};

export default CustomButton;
export type { ButtonProps };
